// extracted by mini-css-extract-plugin
module.exports = {"post":"post-module--post--3Z6TV","contentSlide":"post-module--contentSlide--3tzyj","centerSlide":"post-module--centerSlide--2Ll6N","fadeInOut":"post-module--fadeInOut--VmuwA"};